import React from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";

export default function PoliticaTrocas() {
    return (
        <Box sx={{ bgcolor: "#ffffff", overflowX: "hidden", pb: 8 }}>
            <Box
                sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    py: { xs: 6, md: 8 },
                    borderRadius: { xs: "0 0 20px 20px", md: "0 0 60px 60px" },
                    textAlign: "center",
                    boxShadow: 3,
                    mb: 6,
                }}
            >
                <Container maxWidth="md">
                    <SwapHorizOutlinedIcon sx={{ fontSize: 48, opacity: 0.9, mb: 1 }} />
                    <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 2, letterSpacing: "-0.03em" }}>
                        Política de Trocas e Devoluções
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 400, opacity: 0.9, maxWidth: 600, mx: "auto", lineHeight: 1.6 }}>
                        Sua satisfação é nossa prioridade. Conheça as regras para trocas e devoluções de forma transparente.
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="md">
                <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, border: "1px solid", borderColor: "divider" }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main", mb: 2 }}>
                        Prazo para solicitação
                    </Typography>
                    <Typography variant="body1" color="#1e1e1e" sx={{ lineHeight: 1.8, mb: 2 }}>
                        O cliente dispõe de <strong>3 (três) dias úteis</strong>, a contar da data de recebimento do produto,
                        para solicitar a troca ou devolução, em conformidade com o Código de Defesa do Consumidor (Art. 49).
                    </Typography>
                    <Typography variant="body1" color="#1e1e1e" sx={{ lineHeight: 1.8, mb: 3 }}>
                        Só efetuamos trocas de produtos com defeito, mal funcionamento e casos em que o produto recebido seja
                        diferente do pedido realizado.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main", mb: 2 }}>
                        Condições para troca ou devolução
                    </Typography>
                    <List dense>
                        {[
                            "Grave um vídeo antes de abrir cada produto, com a caixa ainda da transportadora.",
                            "Realize o teste do produto em vídeo para fins de controle e eventual troca.",
                            "A imagem de quem aparecer no vídeo não será utilizada, sendo o material destinado apenas à análise interna.",
                        ].map((item, i) => (
                            <ListItem key={i} sx={{ py: 0.5 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                    <CheckCircleOutlinedIcon color="primary" fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={item} primaryTypographyProps={{ variant: "body2", color: "#1e1e1e" }} />
                            </ListItem>
                        ))}
                    </List>

                    <Typography variant="body2" color="#1e1e1e" sx={{ mt: 2, lineHeight: 1.8 }}>
                        Não nos responsabilizamos pelo envio. Tentamos ao máximo compreender a situação de cada cliente, por isso
                        orientamos que consulte o suporte para entender o que pode ser feito em seu caso.
                    </Typography>

                    <Typography variant="body2" color="#1e1e1e" sx={{ mt: 2, lineHeight: 1.8 }}>
                        Cada solicitação será analisada minuciosamente por nossa equipe. Pedimos compreensão e reforçamos que os
                        canais oficiais para solução de problemas são o WhatsApp listado em nosso site e o e-mail{" "}
                        <strong>emma.suporte@gmail.com</strong>.
                    </Typography>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main", mb: 2 }}>
                        Como solicitar
                    </Typography>
                    <Typography variant="body1" color="#1e1e1e" sx={{ lineHeight: 1.8 }}>
                        Entre em contato pelo e-mail <strong>emma.suporte@gmail.com</strong> ou pelo canal de atendimento informando
                        o número do pedido e o motivo da solicitação. Nossa equipe retornará em até 24 horas úteis com o passo a passo
                        para envio do produto e análise.
                    </Typography>

                    <Typography variant="body2" color="#1e1e1e" sx={{ mt: 4, fontStyle: "italic" }}>
                        Última atualização: Abril de 2026. A EMMA reserva-se o direito de alterar esta política, mantendo sempre
                        o respeito ao Código de Defesa do Consumidor.
                    </Typography>
                </Paper>
            </Container>
        </Box>
    );
}
